<template>
  <div class="vld-parent">
    <loading :active.sync="isLoading" 
    :can-cancel="false" 
    :on-cancel="onCancel"
    :color="'#12B3BD'"
    :height="120"
    :width="400"
    :is-full-page="fullPage"></loading>
    
    <!-- <label><input type="checkbox" v-model="fullPage">Full page?</label>
    <button @click.prevent="doAjax">fetch Data</button> -->
  </div>
</template>

<script>
    // Import component
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: "VueLoading",
  data() {
    return {
      fullPage: true
    }
  },
  props: {
    isLoading: Boolean
  },
  components: {
      Loading
  },
  methods: {
    doAjax() {
      this.isLoading = false;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false
      },5000)
    },
    onCancel() {
      console.log('User cancelled the loader.')
    }
  }
}
</script>
